<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="角色名称：" prop="name">
                    <el-input v-model.trim="form.name" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass"
                        @click="onSearch">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="text-align: right;margin-bottom: 8px;">
            <el-button type="primary" size="small" @click="add">新建</el-button>
        </div>
        <el-table :data="list" size="mini">
            <el-table-column label="角色名称">
                <template v-slot="scope">
                    <span>{{ scope.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="340px">
                <template v-slot="scope">
                    <el-button type="info" size="mini" class="btnClass" @click="edit(scope.row)">编辑</el-button>
                    <el-button type="danger" size="mini" @click="del(scope.row)">删除</el-button>
                    <router-link style="margin-left:10px;margin-right: 10px;"
                        :to="'/salespartner/permission/user/rolePower/' + scope.row.id">
                        <el-button type="success" size="mini">权限分配</el-button>
                    </router-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="pagination.page"
            :page-size="pagination.limit" layout="total, prev, pager, next" :total="pagination.total" background>
        </el-pagination>
        <el-dialog v-model="addVisible" :title="isEdit ? '编辑角色' : '新增角色'" width="400px">
            <el-form ref="addFormRef" :model="addForm" size="small" label-width="90px" :rules="addRules">
                <el-form-item label="角色名称：" prop="name">
                    <el-input v-model="addForm.name" autocomplete="off" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button size="small" @click="addVisible = false">取消</el-button>
                    <el-button type="primary" size="small" @click="update(addFormRef)">
                        确认
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { onMounted, reactive, ref, toRaw } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import util from '../../../../util/util'
import api from '../../../../axios/api'
import dayjs from 'dayjs'

export default {
    setup() {
        const form = reactive({
            name: ''
        })
        const pagination = reactive({
            page: 1,
            limit: 16,
            total: 0
        })
        const formRef = ref()
        const list = ref([])
        const addVisible = ref(false)
        const addForm = reactive({
            name: ''
        })
        const addFormRef = ref()
        const addRules = reactive({
            name: [
                { required: true, message: '请输入名称', trigger: 'blur' }
            ]
        })
        const partnerList = ref([])
        const isEdit = ref(false)

        const handleCurrentChange = (val) => {
            pagination.page = val
            onSearch()
        }

        const onSearch = async () => {
            const res = await api.SalesPartnerPermissionRoleList({
                ...toRaw(form),
                page: pagination.page,
                limit: pagination.limit
            })
            if (res.data.code === 200) {
                const { data, page_info } = res.data.data
                list.value = data
                pagination.total = page_info.total
                pagination.page = page_info.current_page
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const add = () => {
            addVisible.value = true
            isEdit.value = false
            addForm.name = ''
            addFormRef.value?.clearValidate()
        }

        const edit = (row) => {
            addVisible.value = true
            addForm.name = row.name
            addForm.id = row.id
            isEdit.value = true
            addFormRef.value?.clearValidate()
        }

        const resetForm = (formEl) => {
            if (!formEl) return
            formEl.resetFields()
            onSearch()
        }

        const update = async (formEl) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    try {
                        const apiMethod = isEdit.value ? api.SalesPartnerPermissionRoleUpdate : api.SalesPartnerPermissionRoleCreate
                        let params = {}
                        if (isEdit.value) {
                            params.name = addForm.name
                            params.id = addForm.id
                        } else {
                            params = toRaw(addForm)
                        }
                        const res = await apiMethod(params)
                        if (res.data.code == 200) {
                            ElMessage.success('成功')
                            addVisible.value = false
                            onSearch()
                        } else {
                            ElMessage.error(res.data.msg)
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        const del = (row) => {
            ElMessageBox.confirm('你确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const res = await api.SalesPartnerPermissionRoleDelete({
                        id: row.id
                    })
                    if (res.data.code == 200) {
                        ElMessage.success('删除成功')
                        onSearch()
                    } else {
                        ElMessage.error('删除失败' + res.data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    ElMessage.info('已取消删除')
                })
        }

        onMounted(() => {
            onSearch()
        })

        return {
            form,
            onSearch,
            list,
            formRef,
            pagination,
            handleCurrentChange,
            add,
            resetForm,
            util,
            dayjs,
            addVisible,
            addForm,
            addRules,
            partnerList,
            addFormRef,
            update,
            edit,
            isEdit,
            del
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
        padding-left: 16px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }

}
</style>
